import React, { createContext, useContext, useState, ReactNode } from "react";

// Define types for context and props
interface AuthContextType {
  isAuthenticated: AuthToken | null;
  login: (accessToken: AuthToken) => void;
  logout: () => void;
  userDetails: UserDetails | null;
  setUserDetails: (details: any) => void;
  hasAuthenticated: string | null;
}

interface AuthToken {
  access_token: string;
}

// interface UserDetails {
//   permissions:permissions[]
// }

export type UserDetails = {
  email: string;
  username: string;
  userId: string;
  permissions: Permissions[];
  role: any;
  profile: any;
};

interface AuthProviderProps {
  children: ReactNode;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

function AuthProvider({ children }: AuthProviderProps) {
  const [isAuthenticated, setIsAuthenticated] = useState<AuthToken | null>(
    () => {
      const initialAccessToken = localStorage.getItem("accessToken");
      if (initialAccessToken) {
        return { access_token: initialAccessToken };
      }
      return null;
    }
  );

  const hasAuthenticated = isAuthenticated?.access_token || null;

  const [userDetails, setUserDetails] = useState<UserDetails | null>(null);

  const login = (accessToken: AuthToken) => {
    if (accessToken) {
      if (accessToken.access_token) {
        localStorage.setItem("accessToken", accessToken.access_token);
      }
      setIsAuthenticated(accessToken);
      sessionStorage.removeItem("chats");
    }
  };

  const logout = () => {
    localStorage.removeItem("accessToken");

    setUserDetails(null);
    setIsAuthenticated(null);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login,
        logout,
        userDetails,
        setUserDetails,
        hasAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export { AuthContext, AuthProvider, useAuth };
